import React, { useState } from "react";
import image2 from "../../images/WW-Hero-1.jpg";
import { Helmet } from "react-helmet";

import styles from "./index.module.css";

export default function FaxsPage() {
	const [selected, setSelected] = useState(null);

	const toggle = (i) => {
		if (selected === i) {
			return setSelected(null);
		}

		setSelected(i);
	};

	return (
		<div className={styles.FaxsPage}>
			<Helmet>
				<title>Wet Willie's Franchise | Faqs</title>
			</Helmet>
			<div className={styles.figureContainer}>
				<figure>
					<img src={image2} alt="hero" />
				</figure>
			</div>
			<div className={styles.header}>
				<h1>FAQS</h1>
			</div>
			<div className={styles.articleContainer}>
				<article>
					<section className={styles.section2}>
						<div className={styles.accordion}>
							{data.map((item, i) => (
								<div className={styles.item}>
									<div className={styles.titleBox}>
										<span>
											{selected === i ? "-" : "+"}
										</span>
										<h1
											onClick={() => {
												toggle(i);
											}}
										>
											{item.title}
										</h1>
									</div>
									<div className={styles.hiddenBox}>
										<p
											className={
												selected === i
													? styles.contentShow
													: styles.content
											}
										>
											{item.content}
										</p>
									</div>
								</div>
							))}
						</div>

						<br />
					</section>
				</article>
			</div>
		</div>
	);
}

const data = [
	{
		title: "Does Wet Willie's offer financing?",
		content:
			"We do not provide direct financing; however, there are numerous lenders that are familiar with Wet Willie's and are interested in communicating with our franchisees regarding their lending needs.",
	},
	{
		title: "How much money can I expect to make?",
		content:
			"There are numerous factors that affect the profitability of a restaurant, including sales volume, location, the size of the restaurant, employee and employee management, competition, managerial skill, dedication, and the ability to manage the costs of the business appropriately. During your due diligence and after a thorough investigation of our franchise program, you should have the data necessary to make an informed business decision as to whether investing in a Wet Willie's franchise is compatible with attaining your personal business and financial goals. In regard to specific information about the potential sales, operating costs, and profitability of a franchise, Wet Willie's or otherwise, it is advisable to contact existing franchise owners to learn first-hand of their experience. Wet Willie's will provide you with a list of our franchise owners via the Franchise Disclosure Document (\"F.D.D.\"). We do not require our franchise owners to provide you with their personal financial information, but it has been our experience that many of them are willing to share information about their businesses and how they do, and their satisfaction with both the concept and franchisor. No employee of Wet Willie's may furnish any specific oral or written information regarding the potential sales, costs, income, or profits of a new Wet Willie's franchise other than that provided in our F.D.D. The intent of this policy is consistent with our commitment not to, in any way, mislead a potential franchisee; also, with the intent of the Federal Trade Commission that each investor should make an independent investigation as to the profitability of a business opportunity and how it applies to their particular situation. We do, however, provide certain unaudited historical sales and cost information on our corporately owned restaurants in item 19 of our F.D.D. The F.D.D. also contains sample agreements such as our Franchise Agreement.",
	},
	{
		title: "What is the Royalty Fee?",
		content:
			"For domestic restaurants, the royalty rate is 5% of gross sales, exclusive of sales tax, and is paid weekly.",
	},
	{
		title: "Is there an Advertising Fee?",
		content:
			"Yes; the current advertising contribution is 1.5% of gross sales for domestic restaurants. These funds are utilized for the creative development of our menu, photography, video for commercials and product development and testing. Wet Willie's also requires 2% of your gross sales be spent in local advertising within your market. Please note that all advertising and promotions must be approved in advance by Wet Willie's Management Corp.",
	},
	{
		title: "What is a typical Wet Willie's store size?",
		content:
			"Currently there are wide variations in the sizes of the different Wet Willie's locations throughout the country. These variations exist because of local market conditions, liquor license requirement and fire code requirements. Wet Willie's locations with a kitchen typically require 3500 to 5000+ square feet. Wet Willie's without a kitchen area or with a limited kitchen typically require less square footage.",
	},
	{
		title: "Do I have to have a kitchen?",
		content:
			"There is no specific requirement from Wet Willie's to have a kitchen, however, there are local and possibly state laws that regulate your ability to sell alcoholic beverages when a kitchen is not part of the business. These questions may be better answered locally, however, if local regulations require a kitchen in order to be open seven days per week then a kitchen will be required.",
	},
	{
		title: "How do I get my liquor license?",
		content:
			"In many states and municipalities there are licensing requirements on both the local and state levels. This is something best explored locally within your community and with legal counsel.",
	},
	{
		title: "Do you offer investment opportunities that don't require my full time commitment?",
		content:
			'While investment groups are allowed and encouraged we still require at least one member of the investment team to be an active owner in the business. Active owner does not necessarily mean a managing partner working daily in the store but it does require a higher level of commitment and management than that of someone who could be classified as a silent or absentee owner. Individual owners, those without partners, will be required to be active in the daily operation of their Wet Willie\'s franchise. Again, this does not necessarily mean they serve as the General Manager but they will be required to work in the franchise business and ensure proper operation. Preferential treatment for new expansion is typically given to those individuals that are classified as "owner-operators", however, this does not guarantee you will be awarded a franchise and does not automatically preclude you from opening in any particular area.',
	},
	{
		title: "Does Wet Willie's have preferred contractors?",
		content:
			"Wet Willie's Management Corp. will assist in site selection for the franchisee and provide specifications for construction, furniture, fixtures and equipment. However, it is the franchisee's responsibility to work with an engineer and architect to develop site plans, architectural plans, civil drawings, obtain permits and construct their restaurant/bar. All sites must be accepted by Wet Willie's and all final plans and specifications must be reviewed and approved by our design and construction team. A franchisee may either purchase or lease the land and building, or may lease the premises in which the restaurant will operate.",
	},
	{
		title: "How is my site approved?",
		content:
			"It is the responsibility of the franchise owner to acquire suitable locations, typically three possible choices within a marketplace to submit for approval; however, we will work with you during the site selection process, and all sites must be reviewed and accepted by Wet Willie's Management Corp.",
	},
	{
		title: "Who will train me to operate a Wet Willie's?",
		content:
			"At Wet Willie's, we're all about creating \"Global Cooling\" for our customers and our franchisees. That's why, no matter where you are in your journey as a Wet Willie's franchisee, we're always going to be there to help through our Global Cooling team. At Wet Willie's we offer: Extensive field support teams Site selection assistance Comprehensive store design and construction support Management and ongoing training programs Financial analysis, operations evaluation and strategic planning Wide-ranging marketing services, including graphic design, public relations, social media, local store marketing and advertising support Training in our Savannah, GA headquarter Onsite training before and during opening.",
	},
	{
		title: "After I open, will there be additional support?",
		content:
			"Wet Willie's has a highly trained staff of experts on call to answer all your operational and culinary questions. This team is comprised of Executive and Corporate Chefs and Corporate operations personnel trained in every aspect of store management and operation.",
	},
	{
		title: "How soon can I open my very own Wet Willie's?",
		content:
			"Typically it will take 6-12 months before your Wet Willie's is ready to open, in limited cases this time frame can be expedited but franchisees should plan on taking a longer time rather than an abbreviated time. Time frames are dictated by local regulations, zoning, weather and other factors that change by market. Franchisees should have sufficient capital to support themselves and their build-out efforts while the process is being completed.",
	},
	{
		title: "Can I open more than one unit?",
		content:
			"Additional units are approved on a case by case basis and no exclusivity can be offered for a particular region or market.",
	},
	{
		title: "How many employees do I need to plan to hire?",
		content:
			"Each Wet Willie's store is different depending on market conditions, kitchen circumstances, training personnel, etc. Wet Willie's will work with you before and after opening to ensure staffing is adequate but not excessive.",
	},
	{
		title: "Do I have to live in the same area as my Wet Willie's?",
		content:
			"Not necessarily, however, there is the requirement to be an active participant in the overall management of your Wet Willie's franchise. If ownership is a partnership then only one partner has this responsibility, if ownership rests with one person then that one person has the responsibility. Again, this does not necessarily mean that you have to serve as the General Manager only that you have an active role in the management of your franchise business.",
	},
	{
		title: "Will you be at a trade show near me any time soon?",
		content:
			'Please see our "Events" page for updates on all past and upcoming events and trade shows.',
	},
	{
		title: "Is there a charge for the training program?",
		content:
			'Currently there is no charge for training; however, you are required to be present in the Savannah, GA market for 8 weeks for the training program. The costs associated with attending this training are yours to bear. You will be responsible for all travel expenses, room and board, etc. while training outside your market. You will also be responsible for all expenses associated with our "Global Cooling Team" travel, etc. when they visit your store for your initial onsite training and Grand Opening.',
	},
];
